<template>

    <div :class="render ? 'fuid-totalinfo fuid-totalinfo__in':'fuid-totalinfo fuid-totalinfo__out' ">

        <div v-for="(alumno,index) in getMatriculaAlumnos" :key="index" class="fuid-totalinfo__pupil pt-3 pb-2">

            <strong class="pr-3 fuid-totalinfo_name">{{alumno.name}}</strong>

            <div class="pt-2">

                <div class="text-right">

                    <div v-for="(matricula,indexm) in alumno.matriculas" :key="indexm" class="p-2 fuid-totalinfo__bg" :class="indexm != alumno.matriculas.length - 1 ? 'fuid-totalinfo__line':''">
                        
                        <div>

                            <span class="d-block"><strong>{{ $t(`languages.${matricula.tCode}`) }}</strong>:  {{ matricula.nivelName }}</span>
                            <span v-if="$i18n.locale=='eu'">{{ matricula.infoeu }}</span><span v-else>{{ matricula.info }}</span>

                        </div>

                        <div v-if="paymentType==2" class="d-flex justify-content-end"> <strong>{{ getPriceWithIncrement(matricula.price) }}</strong> <span>€</span></div>
                        <div v-else class="d-flex justify-content-end"> <strong>{{ matricula.price }}</strong> <span>€</span></div>

                    </div>
                    
                </div>        

            </div>

        </div>

        <div class="d-flex justify-content-end align-items-center fuid-totalinfo__total pt-2 pb-2"><span>{{ $t('payment.total') }}: </span> <strong>{{total}}</strong> <span>€</span></div>

    </div>

</template>

<script>

    import { mapGetters } from 'vuex'

    import priceIncrement from '@/mixins/priceIncrement'

    export default {

        props:['total','paymentType'],

        mixins: [priceIncrement],

        computed: {

            ...mapGetters('Matricula', ['getMatriculaAlumnos']),
            ...mapGetters('Prematriculas', ['getGroupIncrement']),

            render: function() {

                let render = false

                if(this.total != 0) {

                    render = true

                }

                return render

            }

        }

    }

</script>